export default "__VITE_ASSET__B1sWV1GR__ 400w, __VITE_ASSET__CMBsAvVI__ 800w, __VITE_ASSET__CM2FE6lX__ 1200w";